import { createSlice } from '@reduxjs/toolkit'

// Setup the initial state

const initialState = {
  consultIfClientHasCurrentAccount: {},
  consultIfClientHasActiveProducts: {},
  openAccount: {
    isLoading: false,
    success: false,
    error: null,
    successfulProducts: [],
    currentProduct: null,
  },
};

export const accountsSlice = createSlice({
  name: 'accounts',
  initialState,
  reducers: {

    // Consult if the client has a Current Account

    setConsultIfClientHasCurrentAccountLoading: (state) => {
      state.consultIfClientHasCurrentAccount = {
        isLoading: true,
      };
    },

    setConsultIfClientHasCurrentAccountSuccess: (state, action) => {
      state.consultIfClientHasCurrentAccount = {
        hasAccount: action.payload
      };
    },

    setConsultIfClientHasCurrentAccountFailure: (state, action) => {
      state.consultIfClientHasCurrentAccount = {
        error: action.payload,
      }
    },

    // Consult if the client has an Active Product

    setConsultIfClientHasActiveProductsLoading: (state) => {
      state.consultIfClientHasActiveProducts = {
        isLoading: true,
      };
    },

    setConsultIfClientHasActiveProductsSuccess: (state, action) => {
      state.consultIfClientHasActiveProducts = {
        hasActiveProduct: action.payload
      };
    },

    setConsultIfClientHasActiveProductsFailure: (state, action) => {
      state.consultIfClientHasActiveProducts = {
        error: action.payload,
      }
    },

    clearconsultIfClientHasActiveProductsStore: (state) => {
      state.consultIfClientHasActiveProducts = {}
    },


    // Open Account

    setOpenAccountLoading: (state) => {
      state.openAccount.isLoading = true;
      state.openAccount.error = null;
    },

    setOpenAccountCurrentProduct: (state, action) => {
      state.openAccount.currentProduct = action.payload;
    },

    setOpenAccountSuccess: (state) => {
      state.openAccount.isLoading = false;
      state.openAccount.success = true;
      state.openAccount.currentProduct = null;
    },

    setAddOpenAccountSuccessfulProduct: (state, action) => {
      state.openAccount.successfulProducts.push(action.payload);
    },

    setOpenAccountFailure: (state, action) => {
      state.openAccount.isLoading = false;
      state.openAccount.error = action.payload;
    },

    clearOpenAccountStore: (state) => {
      state.openAccount = {
        isLoading: false,
        success: false,
        error: null,
        successfulProducts: [],
        currentProduct: null,
      }
    },

  },
})

export const {
  setConsultIfClientHasCurrentAccountLoading, setConsultIfClientHasCurrentAccountSuccess, setConsultIfClientHasCurrentAccountFailure,
  setConsultIfClientHasActiveProductsLoading, setConsultIfClientHasActiveProductsSuccess, setConsultIfClientHasActiveProductsFailure, clearconsultIfClientHasActiveProductsStore,
  setOpenAccountLoading, setOpenAccountCurrentProduct, setOpenAccountSuccess, setAddOpenAccountSuccessfulProduct, setOpenAccountFailure, clearOpenAccountStore,
} = accountsSlice.actions

export default accountsSlice.reducer;